import actionTypes from './video.actionTypes';
                  
const initialState = {
  isLoadingConfiguration: false,
  isVideoCreatorLoaded: false,
  isVideoPlayerLoaded: false,
  isVideoV2ConfigurationLoaded: false,
  configuration: undefined,
  videoV2Configuration: {
    idpToken: '',
    isVideoV2Enabled: false,
  },
};


export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_VIDEO_CONFIGURATION_BEGIN: return getVideoConfigurationBegin(state);
    case actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS: return getVideoConfigurationSuccess(state, action);
    case actionTypes.GET_VIDEO_CONFIGURATION_FAILURE: return getVideoConfigurationFailure(state);
    case actionTypes.SET_VIDEO_V2_CONFIGURATION: return setVideoV2Configuration(state, action);
    case actionTypes.SET_VIDEO_V2_CONFIGURATION_FAILURE: return setVideoV2ConfigurationFailed(state, action);
    case actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS: return setVideoRecorderLoadSuccess(state);
    case actionTypes.SET_VIDEO_CREATOR_LOAD_FAILURE: return setVideoRecorderLoadFailure(state);
    case actionTypes.SET_VIDEO_PLAYER_LOAD_SUCCESS: return setVideoPlayerLoadSuccess(state);
    case actionTypes.SET_VIDEO_PLAYER_LOAD_FAILURE: return setVideoPlayerLoadFailure(state);
      
    default:
      return state;
  }
}


const getVideoConfigurationBegin = (state) => {
  return {
    ...state,
    isLoadingConfiguration: true,
  };
};

const getVideoConfigurationSuccess = (state, action) => {
  let configuration = action.data.configuration;  
  return {
    ...state,
    isLoadingConfiguration: false,
    configuration: configuration,
  };
};

const getVideoConfigurationFailure = state => {
  return {
    ...state,
    isLoadingConfiguration: false
  };
};

const setVideoV2Configuration = (state, action) => {
  return {
    ...state,
    videoV2Configuration: action.data.videoV2Configuration,
    isVideoV2ConfigurationLoaded: true
  };
};

const setVideoV2ConfigurationFailed = (state, action) => {
  return {
    ...state,
    videoV2Configuration: initialState.videoV2Configuration,

    // Even though this is a failure, we still want to set this to true so that the form viewer/editor can render 
    // without waiting for a video configuration that will never come.
    isVideoV2ConfigurationLoaded: true
  };
};

const setVideoRecorderLoadSuccess = state => {
  return {
    ...state,
    isVideoCreatorLoaded: true
  };
};

const setVideoRecorderLoadFailure = state => {
  return {
    ...state,
    isVideoCreatorLoaded: false
  };
};

const setVideoPlayerLoadSuccess = state => {
  return {
    ...state,
    isVideoPlayerLoaded: true
  };
};

const setVideoPlayerLoadFailure = state => {
  return {
    ...state,
    isVideoPlayerLoaded: false
  };
};

